import axios from "axios"
import { toast } from "react-toastify";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL


export const CreateEnhancement=async(formData)=>{
    console.log(formData);
    try{
        const responce = await axios.post(`${BACKEND_URL}/api/enhancement`,formData);
        if(responce==="OK"){
            toast.success("Added")
        }

        return responce
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const GetEnhancement =async()=>{
    try{
        const responce = await axios.get(`${BACKEND_URL}/api/enhancement`);
        return responce;
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const GetByIdEnhancement =async(amdno,lcRefNo)=>{
    try{
        const responce = await axios.get(`${BACKEND_URL}/api/enhancement/${amdno}/${lcRefNo}`);
        return responce.data;
    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const updateEnhancement = async(formData)=>{
    try{
        const responce = await axios.patch(`${BACKEND_URL}/api/enhancement`,formData)
        return responce.data


    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}


export const CheckAmdNo = async(lcReferenceNo,amendmentNo)=>{
    try{
        const responce = await axios.post(`${BACKEND_URL}/api/enhancement/check/${lcReferenceNo}/${amendmentNo}`)
        return responce.data


    }catch(error){
        const message = (error.response && error.response.data && error.response.data.message
        ) || error.message || error.toString()
        toast.error(message)
    }
}